import diff from "../diff";

export default function serializePaymentProfile(data, initialData) {
  return {
    ...data,
    translations_attributes: data.translations && diff(data.translations, initialData && initialData.translations),
    translations: undefined,
    additional_fee: (data.additional_fee && data.additional_fee.value) || null,
    additional_fee_currency: (data.additional_fee && data.additional_fee.currency) || null,
    installments_attributes:
      data.installments &&
      diff(
        data.installments.map((installment) => ({
          ...installment,
          amount: (installment.amount && installment.amount.value) || null,
          amount_currency: (installment.amount && installment.amount.currency) || null,
        })),
        initialData && initialData.installments
      ),
    installments: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializePaymentProfile.js